(() => {
    console.log('%c👍🏼 Case Study Videos', 'color: yellow');

    const caseStudyVideos = document.querySelectorAll('.case-study-video');
    caseStudyVideos.forEach(caseStudyVideo => {
        
        const video =  caseStudyVideo.querySelector('video');
        let observer = new IntersectionObserver((entries, observer) => { 
            
            entries.forEach(entry => {
                if(entry.intersectionRatio >0.7 ){
                    if(video.paused) {
                        video.play(); 
                    }  
                }
                else {
                    video.pause();
                }
            });
        }, {threshold: 0.7});
        observer.observe(video);

        const audioToggle = caseStudyVideo.querySelector('.case-study-video__audio-toggle');
        const setupAudioToggle = () => {
       
            const muteIcon = audioToggle.querySelector('[data-audio-toggle="mute"]');
            const unmuteIcon = audioToggle.querySelector('[data-audio-toggle="unmute"]');
    
            const toggleAudio = (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                // if video sound is on, turn it off
                if (!video.muted) {
                    video.muted = true;
                    muteIcon.classList.add('hidden');
                    unmuteIcon.classList.remove('hidden');
                } else {
                    video.muted = false;
                    muteIcon.classList.remove('hidden');
                    unmuteIcon.classList.add('hidden');
    
                    if (!audioToggle.dataset.clicked) {
                        audioToggle.dataset.clicked = 'true';
    
                        // restart video
                        video.currentTime = 0;
                        video.play();
                    }
                }
            };
    
            // Add click event listener
            audioToggle.addEventListener('click', toggleAudio);
        };
    
        if(audioToggle) {
            setupAudioToggle();
        } 
    })
})();